var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 78,
    viewBox: "0 0 91 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2499 59.0666H15.2499C14.0499 59.0666 13.1499 58.1666 13.1499 56.9666V21.3666C13.1499 20.1666 14.0499 19.2666 15.2499 19.2666H76.1499C77.3499 19.2666 78.2499 20.1666 78.2499 21.3666V56.9666C78.2499 58.1666 77.3499 59.0666 76.2499 59.0666Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5498 52.0666L72.9498 26.2666",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1497 54.0667C30.1497 53.6667 29.9497 53.3667 29.5497 53.2667L18.9497 51.9667L24.6497 42.8667C24.8497 42.5667 24.7497 42.0667 24.4497 41.8667C24.1497 41.6667 23.6497 41.7667 23.4497 42.0667L17.1497 52.0667C17.0497 52.2667 17.0497 52.5667 17.1497 52.7667C17.2497 52.9667 17.4497 53.1667 17.6497 53.1667L29.3497 54.6667C29.4497 54.6667 29.6497 54.6667 29.7497 54.5667C29.9497 54.4667 30.0497 54.2667 30.1497 54.0667Z",
    fill: "#F69A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1496 36.4668C66.8496 36.2668 66.7496 35.8668 66.9496 35.4668L72.6496 26.3668L62.0496 25.0668C61.6496 25.0668 61.3496 24.6668 61.4496 24.2668C61.4496 23.8668 61.8496 23.5668 62.2496 23.6668L73.9496 25.1668C74.1496 25.1668 74.3496 25.3668 74.4496 25.5668C74.5496 25.7668 74.5496 26.0668 74.4496 26.2668L68.1496 36.2668C68.0496 36.3668 67.9496 36.4668 67.8496 36.5668C67.6496 36.5668 67.3496 36.5668 67.1496 36.4668Z",
    fill: "#F69A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4501 14.3667C66.8501 6.4667 56.8501 1.3667 45.7501 1.3667C34.2501 1.3667 23.9501 6.7667 17.3501 15.1667",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6501 7.46671C72.4501 7.46671 72.2501 7.76671 72.3501 7.96671L73.3501 14.2667L67.1501 12.4667C66.9501 12.3667 66.6501 12.5667 66.6501 12.7667C66.5501 12.9667 66.7501 13.2667 66.9501 13.2667L73.7501 15.2667C73.8501 15.2667 74.0501 15.2667 74.1501 15.1667C74.2501 15.0667 74.3501 14.9667 74.2501 14.7667L73.1501 7.76671C73.1501 7.66671 73.1501 7.56671 73.0501 7.56671C72.9501 7.46671 72.8501 7.36671 72.6501 7.46671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4501 63.9665C66.8501 71.8665 56.8501 76.9665 45.7501 76.9665C34.2501 76.9665 23.9501 71.5665 17.3501 63.1665",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6503 65.5664C66.7503 65.7664 66.9503 65.9664 67.1503 65.8664L73.3503 64.0664L72.3503 70.3664C72.3503 70.5664 72.4503 70.7664 72.6503 70.8664C72.8503 70.9664 73.0503 70.7664 73.1503 70.5664L74.2503 63.5664C74.2503 63.4664 74.2503 63.2664 74.1503 63.1664C74.0503 63.0664 73.8503 63.0664 73.7503 63.0664L66.9503 65.0664C66.8503 65.0664 66.8503 65.1664 66.7503 65.1664C66.6503 65.2664 66.5503 65.4664 66.6503 65.5664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 27.5664H52.55",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8502 32.5664H32.4502",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5501 50.1665H51.3501",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 77,
    fill: "white",
    transform: "translate(0.75 0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02);
export default __webpack_public_path__ + "static/media/logo02.96e4f40400f49bed228ad38ac7cb98c4.svg";
export { ForwardRef as ReactComponent };